import React from 'react';
import EditorialCard from '../EditorialCard';

/**
 * Chapter 02 — BEFORE THE CODE
 * Tells the story of university exploration across web dev, data science, and other areas,
 * framed not as failure, but as discovering that computers could be another workshop.
 */
const BeforeCodeChapter = () => {
  return (
    <section className="before-code-chapter">
      <div className="container-editorial">
        {/* === CHAPTER 02 TITLE HEADER === */}
        <div className="ch02-header">
          <div className="ch02-tag font-mono">
            <span className="ch02-dot" />
            CHAPTER 02 &nbsp;//&nbsp; EXPLORATION
          </div>

          <h2 className="ch02-headline font-display">
            Then I discovered computers could be<br />
            <span className="ch02-accent-text">another workshop.</span>
          </h2>

          <p className="ch02-desc font-body">
            Early in university, I experimented across different domains of computer science, looking for the right fit.
          </p>
        </div>

        <div className="exploration-sequence">
          <EditorialCard variant="standard" className="explore-step">
            <span className="step-label font-mono">01 // WEB DEVELOPMENT</span>
            <h3 className="font-heading">Building Pages</h3>
            <p className="font-body step-desc">Learned HTML, CSS, and basic scripting. Useful, but felt missing a core spark.</p>
          </EditorialCard>

          <EditorialCard variant="standard" className="explore-step">
            <span className="step-label font-mono">02 // DATA SCIENCE</span>
            <h3 className="font-heading">Analyzing Datasets</h3>
            <p className="font-body step-desc">Worked with Python and statistical models. Interesting insights, but lacked instant tangible feedback.</p>
          </EditorialCard>

          <EditorialCard variant="featured" className="explore-step active-step">
            <span className="step-label font-mono" style={{ color: 'var(--accent-gold)' }}>03 // MOBILE ENGINEERING</span>
            <h3 className="font-heading" style={{ color: 'var(--accent-gold)' }}>Software For Mobile Devices</h3>
            <p className="font-body step-desc">Building applications that live directly in people's hands. Instant feedback, real utility, endless creation.</p>
          </EditorialCard>
        </div>
      </div>

      <style>{`
        .before-code-chapter {
          min-height: 100vh;
          padding: 6rem 1.5rem;
          background: #080a0f;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .container-editorial {
          max-width: 900px;
          width: 100%;
          margin: 0 auto;
        }

        .ch02-header {
          text-align: center;
          max-width: 720px;
          margin: 0 auto 3.5rem auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }

        .ch02-tag {
          color: #d4a359;
          font-size: 0.75rem;
          letter-spacing: 0.22em;
          display: flex;
          align-items: center;
          gap: 0.6rem;
          background: rgba(212, 163, 89, 0.08);
          border: 1px solid rgba(212, 163, 89, 0.25);
          padding: 0.4rem 1rem;
          border-radius: 100px;
        }

        .ch02-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #d4a359;
          box-shadow: 0 0 10px #d4a359;
        }

        .ch02-headline {
          font-size: clamp(2.4rem, 5.5vw, 3.8rem);
          line-height: 1.15;
          color: #ffffff;
          margin: 0;
          font-weight: 800;
          letter-spacing: -0.03em;
        }

        .ch02-accent-text {
          color: #d4a359;
          font-style: italic;
          font-family: 'Playfair Display', Georgia, serif;
          font-weight: 500;
        }

        .ch02-desc {
          color: rgba(209, 213, 219, 0.85);
          font-size: clamp(0.95rem, 1.2vw, 1.05rem);
          line-height: 1.6;
          margin: 0;
        }

        .exploration-sequence {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }

        .explore-step {
          transition: transform 0.3s ease, border-color 0.3s ease;
        }

        .explore-step:hover {
          transform: translateX(6px);
        }

        .step-label {
          font-size: 0.72rem;
          color: rgba(156, 163, 175, 0.8);
          letter-spacing: 0.12em;
          display: block;
          margin-bottom: 0.35rem;
        }

        .explore-step h3 {
          font-size: 1.25rem;
          color: #f3f4f6;
          margin-bottom: 0.4rem;
        }

        .step-desc {
          color: rgba(156, 163, 175, 0.85);
          font-size: 0.9rem;
          line-height: 1.5;
        }

        .active-step {
          border-color: rgba(212, 163, 89, 0.4) !important;
          background: rgba(212, 163, 89, 0.04) !important;
        }

        @media (max-width: 640px) {
          .before-code-chapter {
            padding: 4rem 1rem;
          }
          .ch02-header {
            margin-bottom: 2.5rem;
          }
        }
      `}</style>
    </section>
  );
};

export default BeforeCodeChapter;
